const loadSessionStorageState = () => {
  try {
    const serializedState = sessionStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const saveSessionStorageState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('state', serializedState);
  } catch (err) {
    // Should be logged probably but not into console!
  }
};

const initStorePersistence = (store) => {
  store.subscribe(() => {
    saveSessionStorageState({
      listingPage: {
        comparison: store.getState().listingPage.comparison
      }
    });
  });
};

export { initStorePersistence, loadSessionStorageState };
